<h2 mat-dialog-title>Manage Project Stage</h2>

<mat-dialog-content [formGroup]="form" class="flex flex-col gap-4">
  <!-- Project Information Display -->
  <div class="bg-gray-50 p-4 rounded-lg mb-4">
    <h3 class="text-lg font-semibold text-gray-800 mb-2">Project Information</h3>
    <div class="grid grid-cols-2 gap-4 text-sm">
      <div>
        <span class="font-medium text-gray-600">Project Name:</span>
        <span class="ml-2 text-gray-800">{{ project?.project_name || 'N/A' }}</span>
      </div>
      <div>
        <span class="font-medium text-gray-600">Project Code:</span>
        <span class="ml-2 text-gray-800">{{ project?.project_identifier || 'N/A' }}</span>
      </div>
      <div>
        <span class="font-medium text-gray-600">Current Stage:</span>
        <span class="ml-2 px-2 py-1 rounded-full text-xs font-medium"
              [ngClass]="{
                'bg-blue-100 text-blue-800': project?.stage === 'Pre-Planning' || project?.stage === 'Planning',
                'bg-yellow-100 text-yellow-800': project?.stage === 'Survey' || project?.stage === 'Design Revisions & Scope Adjustments',
                'bg-green-100 text-green-800': project?.stage === 'Execution',
                'bg-purple-100 text-purple-800': project?.stage === 'Closure',
                'bg-gray-100 text-gray-800': !project?.stage
              }">
          {{ project?.stage || 'Not Set' }}
        </span>
      </div>
      <div>
        <span class="font-medium text-gray-600">Status:</span>
        <span class="ml-2 text-gray-800">{{ project?.permit_status || 'N/A' }}</span>
      </div>
    </div>
  </div>

  <!-- Stage Management Form -->
  <div class="space-y-4">
    <mat-label class="text-sm font-medium text-gray-700">Project Name</mat-label>
    <mat-form-field appearance="outline" class="w-full">
      <input matInput formControlName="name" readonly />
    </mat-form-field>
      
    <mat-label class="text-sm font-medium text-gray-700">Assigned Lead</mat-label>
    <mat-form-field appearance="outline" class="w-full">
      <mat-select formControlName="assigned_to" placeholder="Select staff member" [disabled]="isLoadingStaff">
        <mat-option *ngIf="isLoadingStaff" disabled>
          <span class="flex items-center">
            <svg class="animate-spin -ml-1 mr-3 h-4 w-4 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Loading staff...
          </span>
        </mat-option>
        <mat-option *ngFor="let staff of staffList" [value]="staff.id">
          {{ staff.full_name }}  ({{ staff.designation }})
        </mat-option>
        <mat-option *ngIf="!isLoadingStaff && staffList.length === 0" disabled>
          No staff members found
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-label class="text-sm font-medium text-gray-700">Select New Stage</mat-label>
    <mat-form-field appearance="outline" class="w-full">
      <mat-select formControlName="stages">
        <mat-option *ngFor="let stage of stages" [value]="stage.name">
          {{ stage.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-label class="text-sm font-medium text-gray-700">Date</mat-label>
    <mat-form-field appearance="outline" class="w-full">  
      <input matInput [matDatepicker]="picker" formControlName="date" />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="gap-2">
  <app-secondary-button (click)="cancel()">
    <span>Cancel</span>
  </app-secondary-button>
  <app-primary-button (click)="submit()" [disabled]="!form.valid">
    <span>Update Stage</span>
  </app-primary-button>
</mat-dialog-actions>

